import getEnv, { Environment, Host } from '@/utils/environment';

const env = getEnv();

export const GTM_ID = env === Environment.PROD ? 'GTM-NWCXLCP' : 'GTM-5BFXG7T';

/**
 * First-party Google tag gateway measurement path (CloudFront → *.fps.goog).
 * Absolute URL required — `@next/third-parties` GoogleTagManager uses `new URL()`.
 * @see https://developers.google.com/tag-platform/tag-manager/gateway/setup-guide
 */
export const GTM_MEASUREMENT_PATH = '/gtm-metrics';

/** Prod gateway script URL; undefined in lower envs (library default: googletagmanager.com). */
export const GTM_SCRIPT_URL =
  env === Environment.PROD
    ? `https://${Host.PROD}${GTM_MEASUREMENT_PATH}/`
    : undefined;
